import PropTypes from 'prop-types';
import React from 'react';

const blueFill = '#2A4473';
const pinkFill = '#EAC9EF';
const greyFill = '#C4C8CC';

/**
 * @description renders a svg resume icon with variable coloring depending on hasUploadedResume prop
 * @property  {boolean} hasUploadedResume - determines the colors of svg
 * @property  {string} className - optional className
 * @property  {number} height - height of the svg
 * @property  {number} width - width of the svg
 * @returns  {React.FunctionComponent} svg resume icon
 */
const ResumeIcon = ({ hasUploadedResume, height, width, className }) => {
    const lineFillColor = hasUploadedResume ? blueFill : greyFill;

    const pinkEllipse = (
        <ellipse
            fill={pinkFill}
            cx="26.7334495"
            cy="29.5238095"
            rx="8.91114983"
            ry="8.85714286"
        />
    );

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={height}
            width={width}
            viewBox="0 0 55 62"
            className={className}
            aria-labelledby="icon-title"
        >
            <title id="icon-title">Resume Icon</title>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M44.0279349 4.39321856c.4921492 0 .891115.39654779.891115.88571428V60.5240366c0 .4891665-.3989658.8857143-.891115.8857143H1.48519164c-.49214922 0-.89111499-.3965478-.89111499-.8857143V5.27893284c0-.48916649.39896577-.88571428.89111499-.88571428H44.0279349zm-.891115 1.77142857H2.37630662V59.6383223H43.1368199V6.16464713z"
                    fill={lineFillColor}
                    fillRule="nonzero"
                />
                <path
                    d="M10.1386798 41.3226593h24.8491601c.4921493 0 .891115-.3965478.891115-.8857142 0-.4891665-.3989657-.8857143-.891115-.8857143H10.1386798c-.49214926 0-.89111503.3965478-.89111503.8857143 0 .4891664.39896577.8857142.89111503.8857142zM10.1386798 46.0133871h24.8491601c.4921493 0 .891115-.3965478.891115-.8857143 0-.4891665-.3989657-.8857143-.891115-.8857143H10.1386798c-.49214926 0-.89111503.3965478-.89111503.8857143 0 .4891665.39896577.8857143.89111503.8857143zM10.1386798 50.7041148h24.8491601c.4921493 0 .891115-.3965478.891115-.8857143 0-.4891665-.3989657-.8857143-.891115-.8857143H10.1386798c-.49214926 0-.89111503.3965478-.89111503.8857143 0 .4891665.39896577.8857143.89111503.8857143z"
                    fill={lineFillColor}
                    fillRule="nonzero"
                />
                {hasUploadedResume ? pinkEllipse : null}
                <path
                    d="M22.5632598 15.0993846c5.8408719 0 10.5760878 4.7067733 10.5760878 10.5119902 0 5.6659849-4.516758 10.3070865-10.213032 10.5065339l-.3630558.0062134c-5.8412526 0-10.5760877-4.7063948-10.5760877-10.5127473 0-5.8052169 4.7352159-10.5119902 10.5760877-10.5119902zm0 1.7714286c-4.8565517 0-8.7938577 3.9136562-8.7938577 8.7405616 0 4.8280411 3.9369252 8.7414559 8.7781778 8.7414559l.3316622-.0056636c4.7220833-.1654518 8.4778755-4.0246387 8.4778755-8.7357923 0-4.8269054-3.937306-8.7405616-8.7938578-8.7405616z"
                    fill={lineFillColor}
                    fillRule="nonzero"
                />
                <path
                    d="M45.8528323 2.46957657l6.3103301 50.59365433-7.877511.9705537c-.4884112.060175-.8352678.5024924-.7747259.9879436.060542.4854511.5055564.8302056.9939676.7700305l8.7618691-1.0795116c.4884156-.0601755.8352731-.5025.7747244-.9879547L47.5112133 1.36722279c-.0608122-.48756681-.5092686-.8327765-.9994244-.7693299L17.4279285 4.3625571c-.4880282.06317119-.8321305.50760878-.7685741.99267914.0635564.48507037.5107039.82708723.9987321.76391604l28.1947458-3.64957572z"
                    fill={lineFillColor}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};

ResumeIcon.propTypes = {
    hasUploadedResume: PropTypes.bool,
    height: PropTypes.number,
    width: PropTypes.number,
    className: PropTypes.string,
};

ResumeIcon.defaultProps = {
    hasUploadedResume: true,
    height: 39,
    width: 30,
    className: 'resume-icon',
};

export default React.memo(ResumeIcon);
